<template>
  <div class="whiteBG">
    <div class="w1200">
      <a-breadcrumb>
        <a-breadcrumb-item><router-link to="/index">首页</router-link></a-breadcrumb-item>
        <a-breadcrumb-item><router-link to="/articleList">营销干货</router-link></a-breadcrumb-item>
        <a-breadcrumb-item>{{ MkArticleData.title }}</a-breadcrumb-item>
      </a-breadcrumb>

      <div class="live_cover">
        <div class="cover_box">
          <img :src="MkArticleData.thumb" alt="" />
        </div>
        <div class="intro_box">
          <div class="intro_title">
            <div class="mk_title" :title="MkArticleData.title">
              {{ MkArticleData.title }}
            </div>
            <div class="d_view">
              <span>
                <span style="margin-right: 32px">
                  <i class="iconfont icon-zwliulanliang"></i>
                  {{ MkArticleData.page_view }}
                </span>
              </span>
              <a-tooltip>
                <template #title>
                  <img :src="MkArticleData.urls" alt="" />
                  <a-button type="primary" @click="copyUrl(MkArticleData.offline_url, MkArticleData.id)">复制链接</a-button>
                </template>
                <i class="iconfont icon-zwfenxiang1"></i>
              </a-tooltip>
            </div>
          </div>
          <div class="intro_details" style="height: 218px">
            <div class="time">
              <i class="iconfont icon-zwzhiboshijian"></i>
              发布时间：<span class="con">{{ MkArticleData.date }}</span>
            </div>
            <div class="num">
              <i class="iconfont icon-zwfenleibiaoqian"></i>
              分类标签：<a-tag color="#3A84FF" v-for="tag in MkArticleData.catag" :key="tag.index"
                @click="goEachTag(tag.name)">{{
                tag.name }}</a-tag>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="w1200">
    <div class="list_content">
      <div class="dlist_left">
        <a-tabs v-model:activeKey="activeKey">
          <a-tab-pane key="1" tab="文章概述">
            <div class="content" v-html="MkArticleData.content"></div>
          </a-tab-pane>
        </a-tabs>
      </div>
      <div class="list_right">
        <!-- 联系我们 -->
        <ContactYL />
        <!-- DTC独立站 -->
        <a class="DtcBanner" href="https://dwz.cn/liUeWWoA" target="_blank">
          <img src="@/assets/images/hotDtcBanner.jpeg" alt="" />
        </a>
        <!-- 热门直播 -->
        <HotLive />
        <!-- 推荐课程 -->
        <HotCourse />
      </div>
    </div>
  </div>
</template>

<script>
import '@/assets/css/list.less'
import '@/assets/css/details.less'
import ContactYL from '@/components/hot/ContactYL.vue'
import HotLive from '@/components/hot/HotLive.vue'
import HotCourse from '@/components/hot/HotCourse.vue'
export default {
  name: 'MkArticleDetails',
  components: { ContactYL, HotLive, HotCourse },
  props: ['articleId'],
  data() {
    return {
      tdk: '',
      liveState: 1,
      activeKey: '1',
      MkArticleData: {},
    }
  },
  mounted() {
    this.getMkData()
    let goUrl = this.isMobile()
    if (goUrl === 1) {
      //移动端地址
      location = `https://acadmin.yinolink.com/bview/${this.articleId}`
    }
  },
  methods: {
    isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      )
      if (navigator.userAgent.match(/pad/i)) {
        flag = false
      }
      localStorage.setItem('isMobile', flag ? 1 : 0)
      let goUrl = flag ? 1 : 0
      return goUrl
    },
    async getMkData() {
      if (this.articleId == undefined) {
        this.$router.push('/articleList')
      }
      const { data: res } = await this.$http.post('blog/view', {
        id: this.articleId,
      })
      this.MkArticleData = res.data
      this.tdk = res.tdk
      this.$nextTick(() => {
        document.title = `${this.tdk.title}`
        document.querySelector('meta[name="keywords"]').setAttribute('content', this.tdk.keyword)
        document.querySelector('meta[name="description"]').setAttribute('content', this.tdk.description)
      })
    },
    copyUrl(url, id) {
      this.$copyText(`https://academy.yinolink.com/articleDetails?id=${id}`).then(
        (e) => {
          this.$message.success('复制成功！')
        },
        (e) => {
          this.$message.error('暂无链接！')
        }
      )
    },
    goEachTag(title) {
      this.$router.push({
        name: 'SearchList',
        query: {
          title: title,
        },
      })
    },
  },
}
</script>

<style lang="less" scoped>
.live_cover {
  .cover_box {
    width: 488px;
    height: 325px;
    overflow: hidden;

    img {
      height: 100%;
    }
  }

  .intro_box {
    width: 692px;
    height: 325px;

    .intro_title {
      width: 100%;
      height: 107px;
      font-size: 20px;
      color: rgba(0, 0, 0, 0.85);
      padding: 20px;

      .mk_title {
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        margin-bottom: 10px;
      }
    }

    .intro_details {
      width: 100%;
      height: 286px;
      background-color: #f9f9f9;
      padding: 20px;

      .time {
        margin-bottom: 20px;
      }
    }
  }
}
</style>
